import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import * as UserDataConfig from '../../pages/user-details/config/user-data.config';
import { Subscription } from 'rxjs';
import { ModalScroll } from 'src/app/shared';
import { UtilService, SERVICE_END_POINT } from 'src/app/shared';
import { NgClass, NgStyle } from '@angular/common';

@Component({
    selector: 'app-product-tiles',
    templateUrl: './product-tiles.component.html',
    styleUrls: ['./product-tiles.component.scss'],
    imports: [NgClass, NgStyle, ReactiveFormsModule]
})
export class ProductTilesComponent implements OnInit {

  @Input() product;
  public userInputDetail;
  @Input() fundingSource;
  @Input() parent: UntypedFormGroup;
  @Input() widthSize = '30';
  @Input() isProductSelected = false;
  @Input() noOfProduct: number;
  @Input() prodID: string;
  @Output() productSelectClickHandler: EventEmitter<any> = new EventEmitter<any>();

  updatedProduct: object;
  docAvalable = true;
  public CMSData;
  private subscriptn: Subscription;
  private imgURL;
  constructor(private btnFocusOnModalClose: ModalScroll, private utilService: UtilService) {  }

  ngOnInit() {
    this.GetCMSDataService();
    this.userInputDetail = UserDataConfig.ElementsConfig.productChoice.products.filter(p => p.productCode === this.product.productCode)[0];          
    this.updateDocumentLink();
  }

  ngOndestroy() {
    this.subscriptn.unsubscribe();

  }


  updateDocumentLink() {
    this.updatedProduct = this.product;
    const keyFeature: any[] = this.product.documentLink.find(p => p.key === 'keyFeatures');
    this.updatedProduct['documentLink'].forEach(element => {
      if (element.key === "keyFeatures") {
        const urlSizeArray = element.urlArray.find(u => u.fundingSource === this.fundingSource);
        element.size = urlSizeArray.size;
        element.url = urlSizeArray.url;
        if (element.size !== '') {
          this.docAvalable = false;
        }
      }
    });
  }

  onProductSelect(value: boolean, productname: string, code: string) {
    this.productSelectClickHandler.emit({ value, productname, code });
  }

  getID(id_value) {
    let s;
    s  =  id_value.replace(/\s/g,  '');
    s = s.charAt(0).toLowerCase() + s.substr(1);
    return s;
  }

  onImageClick(imagelink) {
    window.open(imagelink, '_blank');

  }

  /** Code block for CMS */
GetCMSDataService() {
  const URL = SERVICE_END_POINT.higherEnvironment.CMS_YourProductChoice;
  this.utilService.getCMSData(URL)
  .subscribe(res => {
    this.CMSData = res;
  });
}
/** End of code block for CMS */

}
